/**
 * Opens the Innopay receipt window.
 *
 * @param tid - The Transaction ID (TID) from Innopay.
 */
export const openInnopayReceipt = (tid: string): void => {
  if (typeof window === 'undefined') return;
  
  const url = `https://pg.innopay.co.kr/pay/issue/CardIssue.jsp?TID=${tid}&svcCd=01`;
  const width = 430;
  const height = 700;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  
  window.open(
    url,
    '_blank',
    `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
  );
};
